import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';

const Impressum = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-black text-white">
      {/* Header with back button */}
      <div className="container mx-auto px-4 py-6">
        <Button
          onClick={() => navigate('/')}
          variant="ghost"
          className="text-gold hover:text-gold/80 flex items-center gap-2"
        >
          <ArrowLeft size={20} />
          Zurück zur Startseite
        </Button>
      </div>

      {/* Impressum Content */}
      <div className="container mx-auto px-4 py-12 max-w-4xl">
        <h1 className="text-4xl md:text-5xl font-bold text-gold mb-8">Impressum</h1>
        
        <div className="space-y-8 text-white/90 leading-relaxed">
          {/* Angaben gemäß § 5 TMG */}
          <section>
            <h2 className="text-2xl font-semibold text-gold mb-4">Angaben gemäß § 5 TMG</h2>
            <div className="space-y-2">
              <p className="font-semibold text-lg">Christina Samson</p>
              <p>Bad Girl's Society</p>
              <p>Auf d. Driesch 19</p>
              <p>51107 Köln</p>
              <p>Deutschland</p>
              <p className="mt-4"><span className="text-gold">Rechtsform:</span> Einzelunternehmen</p>
              <p><span className="text-gold">Branche:</span> Social Media Content Marketing Agentur</p>
            </div>
          </section>

          {/* Kontakt */}
          <section>
            <h2 className="text-2xl font-semibold text-gold mb-4">Kontakt</h2>
            <div className="space-y-2">
              <p>
                <span className="text-gold font-semibold">Telefon:</span>{' '}
                <a href="tel:+491634630719" className="hover:text-gold transition-colors">
                  +49 163 4630719
                </a>
              </p>
              <p>
                <span className="text-gold font-semibold">E-Mail:</span>{' '}
                <a href="mailto:info.bad.girl@web.de" className="hover:text-gold transition-colors">
                  info.bad.girl@web.de
                </a>
              </p>
              <p>
                <span className="text-gold font-semibold">Instagram:</span>{' '}
                <a 
                  href="https://instagram.com/bad.girl.society" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="hover:text-gold transition-colors"
                >
                  @bad.girl.society
                </a>
              </p>
            </div>
          </section>

          {/* Verantwortlich für den Inhalt */}
          <section>
            <h2 className="text-2xl font-semibold text-gold mb-4">Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h2>
            <div className="space-y-2">
              <p>Christina Samson</p>
              <p>Auf d. Driesch 19</p>
              <p>51107 Köln</p>
            </div>
          </section>

          {/* Haftungsausschluss (kompakt) */}
          <section>
            <h2 className="text-2xl font-semibold text-gold mb-4">Haftungsausschluss</h2>
            <p className="text-sm text-white/70">
              Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, 
              Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. 
              Als Diensteanbieter sind wir für eigene Inhalte verantwortlich. Wir sind jedoch nicht 
              verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen.
            </p>
          </section>
        </div>

        {/* Back button at bottom */}
        <div className="mt-12 pt-8 border-t border-gold/20">
          <Button
            onClick={() => navigate('/')}
            className="bg-accent-red hover:bg-accent-red/90 text-white px-8 py-3 rounded-full"
          >
            Zurück zur Startseite
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Impressum;
